import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";

const COLORS = {
  main: "#13816F",
  headLight: "#19A58D",
  pastel1: "#CFF0EA",
  pastel2: "#E3F7F3",
  faded: "#F3FBF9",
};

const initialTotal = {
  quantity: 0,
  net: 0,
  policy_fee: 0,
  iva: 0,
  total: 0,
  agency_fee: 0,
  commission: 0,
  agent_fee: 0,
};

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

function sumRows(rows, sign = 1, target) {
  rows.forEach((row) => {
    target.quantity += sign * 1;
    target.net += sign * (Number(row.revised_net_premium) || 0);
    target.policy_fee += sign * (Number(row.policy_fee) || 0);
    target.iva += sign * (Number(row.iva) || 0);
    target.total += sign * (Number(row.total) || 0);
    target.agency_fee += sign * (Number(row.agency_fee) || 0);
    target.agent_fee += sign * (Number(row.agent_fee) || 0);
    target.commission += sign * (Number(row.commission) || 0);
  });
}

function SectionTable({
  title,
  rows,
  isCancel = false,
  separatedAgency = false,
}) {
  const [sectionTotal, setSectionTotal] = React.useState({ ...initialTotal });
  let agencyTotal = { ...initialTotal };
  let currentAgency = "";

  const headersField = () => {
    return (
      <TableRow style={{ background: COLORS.pastel1 }}>
        <TableCell>Policy #</TableCell>
        <TableCell>Issue Date</TableCell>
        <TableCell>From Date</TableCell>
        <TableCell>Client Name</TableCell>
        <TableCell>{isCancel ? "Net Refund" : "Net Prem."}</TableCell>
        <TableCell>Policy Fee</TableCell>
        <TableCell>Mex IVA</TableCell>
        <TableCell>{isCancel ? "Total Refund" : "Total Prem."}</TableCell>
        <TableCell className="agent_fee">Agent Policy Fee</TableCell>
        <TableCell className="agency_fee">Agency Fee</TableCell>
        <TableCell className="commission">Commission</TableCell>
      </TableRow>
    );
  };

  React.useEffect(() => {
    const total = { ...initialTotal };
    rows.forEach((row) => sumRows([row], 1, total));
    setSectionTotal(total);
  }, [rows]);

  return (
    <>
      <TableRow>
        <TableCell
          colSpan={11}
          style={{
            background: isCancel ? COLORS.pastel2 : COLORS.main,
            color: isCancel ? "#000" : "#fff",
            fontWeight: 700,
          }}
        >
          {title}
        </TableCell>
      </TableRow>
      {headersField()}
      {rows.map((row, idx) => {
        let totalAgencyRow = "";
        if (currentAgency !== row.producer_code && separatedAgency) {
          totalAgencyRow = currentAgency != "" && (
            <React.Fragment>
              <TableRow className="odd gradeX">
                <TableCell colSpan={3}></TableCell>
                <TableCell>
                  <strong>
                    Agency Total #{currentAgency}: {agencyTotal.quantity}
                  </strong>
                </TableCell>
                <TableCell>
                  <strong>${fmtMoney(agencyTotal.net)}</strong>
                </TableCell>
                <TableCell>
                  <strong>${fmtMoney(agencyTotal.policy_fee)}</strong>
                </TableCell>
                <TableCell>
                  <strong>${fmtMoney(agencyTotal.iva)}</strong>
                </TableCell>
                <TableCell>
                  <strong>${fmtMoney(agencyTotal.total)}</strong>
                </TableCell>
                <TableCell className="agent_fee">
                  <strong>${fmtMoney(agencyTotal.agent_fee)}</strong>
                </TableCell>
                <TableCell className="agency_fee">
                  <strong>${fmtMoney(agencyTotal.agency_fee)}</strong>
                </TableCell>
                <TableCell className="commission">
                  <strong>${fmtMoney(agencyTotal.commission)}</strong>
                </TableCell>
              </TableRow>
              {headersField()}
            </React.Fragment>
          );
          currentAgency = row.producer_code;
          agencyTotal = { ...initialTotal };
        }
        if (separatedAgency) {
          sumRows([row], 1, agencyTotal);
        }
        return (
          <React.Fragment key={idx}>
            {totalAgencyRow}
            <TableRow key={idx} className="odd gradeX">
              <TableCell>{row.policy_nbr}</TableCell>
              <TableCell>{row.created}</TableCell>
              <TableCell>{row.effective_date}</TableCell>
              <TableCell>{row.client_name}</TableCell>
              <TableCell>
                $
                {fmtMoney(
                  isCancel
                    ? Math.abs(row.revised_net_premium)
                    : row.revised_net_premium
                )}
              </TableCell>
              <TableCell>
                $
                {fmtMoney(isCancel ? Math.abs(row.policy_fee) : row.policy_fee)}
              </TableCell>
              <TableCell>
                ${fmtMoney(isCancel ? Math.abs(row.iva) : row.iva)}
              </TableCell>
              <TableCell>
                ${fmtMoney(isCancel ? Math.abs(row.total) : row.total)}
              </TableCell>
              <TableCell className="agent_fee">
                ${fmtMoney(isCancel ? Math.abs(row.agent_fee) : row.agent_fee)}
              </TableCell>
              <TableCell className="agency_fee">
                $
                {fmtMoney(isCancel ? Math.abs(row.agency_fee) : row.agency_fee)}
              </TableCell>
              <TableCell className="commission">
                $
                {fmtMoney(isCancel ? Math.abs(row.commission) : row.commission)}
              </TableCell>
            </TableRow>
          </React.Fragment>
        );
      })}
      <TableRow className="odd gradeX">
        <TableCell colSpan={3}></TableCell>
        <TableCell>
          <strong>Total: {sectionTotal.quantity}</strong>
        </TableCell>
        <TableCell>
          <strong>${fmtMoney(sectionTotal.net)}</strong>
        </TableCell>
        <TableCell>
          <strong>${fmtMoney(sectionTotal.policy_fee)}</strong>
        </TableCell>
        <TableCell>
          <strong>${fmtMoney(sectionTotal.iva)}</strong>
        </TableCell>
        <TableCell>
          <strong>${fmtMoney(sectionTotal.total)}</strong>
        </TableCell>
        <TableCell className="agent_fee">
          <strong>${fmtMoney(sectionTotal.agent_fee)}</strong>
        </TableCell>
        <TableCell className="agency_fee">
          <strong>${fmtMoney(sectionTotal.agency_fee)}</strong>
        </TableCell>
        <TableCell className="commission">
          <strong>${fmtMoney(sectionTotal.commission)}</strong>
        </TableCell>
      </TableRow>
    </>
  );
}

function ActionButtons({ onGeneratePdf, onGenerateCsv, onBack }) {
  return (
    <GridContainer>
      <GridItem xs={12} sm={4}>
        <Button
          variant="green"
          startIcon={<PrintIcon />}
          onClick={() => onGeneratePdf(1, "pdf")}
          style={{ width: "100%" }}
        >
          PDF
        </Button>
      </GridItem>
      <GridItem xs={12} sm={4}>
        <Button
          variant="green"
          startIcon={<TableRowsIcon />}
          onClick={() => onGenerateCsv(1, "csv")}
          style={{ width: "100%" }}
        >
          CSV
        </Button>
      </GridItem>
      <GridItem xs={12} sm={4}>
        <Button
          style={{
            background: "#FFF",
            borderColor: COLORS.main,
            color: COLORS.main,
            border: "1px solid",
            width: "100%",
          }}
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
        >
          Back To Reports
        </Button>
      </GridItem>
    </GridContainer>
  );
}

export default function Daily({
  title = "",
  infos = [],
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
  separatedAgency,
}) {
  // Totales globales
  const total_total = { ...initialTotal };

  infos.forEach((info) => {
    const agency_total = { ...initialTotal };
    const customer_total = { ...initialTotal };
    sumRows(info.agent?.all || [], 1, agency_total);
    sumRows(info.agent?.cancel || [], -1, agency_total);
    sumRows(info.guest?.all || [], 1, customer_total);
    sumRows(info.guest?.cancel || [], -1, customer_total);
    Object.keys(total_total).forEach((k) => {
      total_total[k] += agency_total[k] + customer_total[k];
    });
  });

  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {Object.entries(forma || {}).map(([k, v]) => (
          <input key={k} readOnly type="hidden" name={k} value={v} />
        ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "#fff", borderRadius: 8 }}
            >
              {/* Encabezado */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <ActionButtons
                    onGeneratePdf={onGeneratePdf}
                    onGenerateCsv={onGenerateCsv}
                    onBack={onBack}
                  />
                </GridItem>
              </GridContainer>
              {/* Fecha y compañía */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Tabla principal */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {infos.map((info, idxInfo) => {
                      const agency_total = { ...initialTotal };
                      const customer_total = { ...initialTotal };
                      sumRows(info.agent?.all || [], 1, agency_total);
                      sumRows(info.agent?.cancel || [], -1, agency_total);
                      sumRows(info.guest?.all || [], 1, customer_total);
                      sumRows(info.guest?.cancel || [], -1, customer_total);

                      return (
                        <React.Fragment key={idxInfo}>
                          <TableRow>
                            <TableCell
                              colSpan={11}
                              style={{
                                background: COLORS.main,
                                color: "#fff",
                                fontWeight: 700,
                              }}
                            >
                              Agency
                            </TableCell>
                          </TableRow>
                          <TableRow className="odd gradeX">
                            <TableCell>{info.agency?.code}</TableCell>
                            <TableCell colSpan={10}>
                              {info.agency?.name}
                            </TableCell>
                          </TableRow>
                          <SectionTable
                            title="HDI Seguros Agency (B) Policies"
                            rows={info.agent?.all || []}
                            separatedAgency={separatedAgency}
                          />
                          <SectionTable
                            title="HDI Seguros Agency (B) Refunds & Cancellations"
                            rows={info.agent?.cancel || []}
                            isCancel
                            separatedAgency={separatedAgency}
                          />
                          <TableRow className="odd gradeX">
                            <TableCell colSpan={3}></TableCell>
                            <TableCell>
                              <strong>
                                Agency (B) Total: {agency_total.quantity}
                              </strong>
                            </TableCell>
                            <TableCell>
                              <strong>${fmtMoney(agency_total.net)}</strong>
                            </TableCell>
                            <TableCell>
                              <strong>
                                ${fmtMoney(agency_total.policy_fee)}
                              </strong>
                            </TableCell>
                            <TableCell>
                              <strong>${fmtMoney(agency_total.iva)}</strong>
                            </TableCell>
                            <TableCell>
                              <strong>${fmtMoney(agency_total.total)}</strong>
                            </TableCell>
                            <TableCell className="agent_fee">
                              <strong>
                                ${fmtMoney(agency_total.agent_fee)}
                              </strong>
                            </TableCell>
                            <TableCell className="agency_fee">
                              <strong>
                                ${fmtMoney(agency_total.agency_fee)}
                              </strong>
                            </TableCell>
                            <TableCell className="commission">
                              <strong>
                                ${fmtMoney(agency_total.commission)}
                              </strong>
                            </TableCell>
                          </TableRow>
                          <SectionTable
                            title="HDI Seguros Agency (C) Policies"
                            rows={info.guest?.all || []}
                            separatedAgency={separatedAgency}
                          />
                          <SectionTable
                            title="HDI Seguros Agency (C) Refunds & Cancellations"
                            rows={info.guest?.cancel || []}
                            isCancel
                            separatedAgency={separatedAgency}
                          />
                          <TableRow className="odd gradeX">
                            <TableCell colSpan={3}></TableCell>
                            <TableCell>
                              <strong>
                                Agency (C) Total: {customer_total.quantity}
                              </strong>
                            </TableCell>
                            <TableCell>
                              <strong>${fmtMoney(customer_total.net)}</strong>
                            </TableCell>
                            <TableCell>
                              <strong>
                                ${fmtMoney(customer_total.policy_fee)}
                              </strong>
                            </TableCell>
                            <TableCell>
                              <strong>${fmtMoney(customer_total.iva)}</strong>
                            </TableCell>
                            <TableCell>
                              <strong>${fmtMoney(customer_total.total)}</strong>
                            </TableCell>
                            <TableCell className="agent_fee">
                              <strong>
                                ${fmtMoney(customer_total.agent_fee)}
                              </strong>
                            </TableCell>
                            <TableCell className="agency_fee">
                              <strong>
                                ${fmtMoney(customer_total.agency_fee)}
                              </strong>
                            </TableCell>
                            <TableCell className="commission">
                              <strong>
                                ${fmtMoney(customer_total.commission)}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                    {/* Grand Total */}
                    <TableRow className="odd gradeX">
                      <TableCell colSpan={3}></TableCell>
                      <TableCell>
                        <strong>
                          HDI Seguros Grand Total: {total_total.quantity}
                        </strong>
                      </TableCell>
                      <TableCell>
                        <strong>${fmtMoney(total_total.net)}</strong>
                      </TableCell>
                      <TableCell>
                        <strong>${fmtMoney(total_total.policy_fee)}</strong>
                      </TableCell>
                      <TableCell>
                        <strong>${fmtMoney(total_total.iva)}</strong>
                      </TableCell>
                      <TableCell>
                        <strong>${fmtMoney(total_total.total)}</strong>
                      </TableCell>
                      <TableCell className="agent_fee">
                        <strong>${fmtMoney(total_total.agent_fee)}</strong>
                      </TableCell>
                      <TableCell className="agency_fee">
                        <strong>${fmtMoney(total_total.agency_fee)}</strong>
                      </TableCell>
                      <TableCell className="commission">
                        <strong>${fmtMoney(total_total.commission)}</strong>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Botones inferiores */}
              <GridContainer style={{ marginTop: 16 }}>
                <GridItem xs={12} sm={6}>
                  &nbsp;
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <ActionButtons
                    onGeneratePdf={onGeneratePdf}
                    onGenerateCsv={onGenerateCsv}
                    onBack={onBack}
                  />
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
